<template>
    <div class="prizeManage">

        <div class="breadcrumb">活动管理 > 奖品管理
            <el-button class="right_f" type="primary" @click="newPrize">新增</el-button>
            <el-button class="right_f" type="primary" @click="goback">返回活动</el-button>
        </div>

        <div class="prize">
            <el-select v-model="online" @change="neirong">
                <el-option label="全部状态" value='-1'></el-option>
                <el-option label="已发布" value='1'></el-option>
                <el-option label="未发布" value='0'></el-option>
            </el-select>

        </div>

        <div class="com-list">

            <el-table :data="prizes" style="overflow-x: auto;">

                <el-table-column prop="index" label="序号" align='center' width="80">
                </el-table-column>
                <el-table-column prop="activityName" label="所属活动" align='center' width="180">
                </el-table-column>
                <el-table-column inline-template label="奖品图标" align='center' width="200" show-overflow-tooltip>
                    <img :src="row.logoUrl">
                </el-table-column>
                <el-table-column prop="prizeName" label="奖品名称" align='center' width="150">
                </el-table-column>
                <el-table-column prop="defineText1" label="第三方奖励ID" align='center' width="200">
                </el-table-column>
                <el-table-column prop="deployTime" label="发放时间" align='center' width="200">
                </el-table-column>
                <el-table-column prop="count" label="已发放数量 / 总量" align='center' width="170">
                </el-table-column>
                <el-table-column prop="online" label="状态" align='center' width="120">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align='center' width="200">
                </el-table-column>
                <el-table-column inline-template label="操作" width="120">
                    <span>
                        <el-button class="option" type="text" @click="showDetail(row.prizeId)">详情</el-button>
                        <el-button class="option" type="text" v-if="row.online == '未发布'" @click="editNew(row.prizeId)">
                            修改</el-button>
                        <el-button class="option" type="text" v-if="row.online == '未发布'" @click="updateStatus(row,0)">发布
                        </el-button>
                        <el-button class="option" type="text" v-if="row.online == '已发布'" @click="updateStatus(row,1)">
                            撤销发布</el-button>
                        <el-button class="option" type="text" v-if="row.online == '未发布'" @click="deletePrize(row)">删除
                        </el-button>
                    </span>
                </el-table-column>

            </el-table>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                online: '-1',
                activityId: '',
                prizes: []
            }
        },
        mounted() {
            //请求获取prizes数据
            this.paramAndGet();
        },
        methods: {
            paramAndGet() {
                let url = window.location.href;
                this.activityId = this.$util.getUrlParam('activityId');
                this.online = this.$util.getUrlParam('online');
                this.getprizes(this.activityId, this.online);
            },
            neirong() {
                location.href = `/#/yunying/activity/prizeManage?activityId=${this.activityId}&online=${this.online}`;
                this.paramAndGet();
            },
            getprizes(activityId, online) {
                this.activityId = activityId;
                this.online = online || -1;
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v2/operate/prize/list?activityId=' + activityId + "&online=" + this.online
                }).then((response) => {
                    if (response.data.error === 10000) {
                        let dataList = response.data.data;
                        //处理获取到的prize数据
                        this.prizes = [];
                        for (let i = 0; i < dataList.length; i++) {
                            let activityName = dataList[i].activityName,
                                index = i + 1,
                                online = dataList[i].online,
                                defineText1 = dataList[i].defineText1,
                                logoUrl = dataList[i].logoUrl,
                                prizeName = dataList[i].prizeName,
                                createTime = new Date(dataList[i].createTime),
                                deployStartTime = new Date(dataList[i].deployStartTime),
                                deployEndTime = new Date(dataList[i].deployEndTime),
                                totalCount = dataList[i].totalCount,
                                prizeId = dataList[i].prizeId,
                                pickCount = dataList[i].pickCount;
                            switch (online) {
                                case 0:
                                    online = '未发布';
                                    break;
                                case 1:
                                    online = '已发布';
                                    break;
                            };
                            this.prizes.push({
                                activityName: activityName,
                                index: index,
                                online: online,
                                logoUrl: logoUrl,
                                defineText1: defineText1,
                                prizeName: prizeName,
                                prizeId: prizeId,
                                createTime: createTime.format("yyyy/MM/dd hh:mm"),
                                count: pickCount + ' / ' + totalCount,
                                deployTime: deployStartTime.format("yyyy/MM/dd hh:mm") + " 至 " + deployEndTime.format("yyyy/MM/dd hh:mm")
                            })

                        }
                    }
                })
            },
            showDetail(id) {
                location.href = "#/yunying/activity/prizeDetail?prizeId=" + id;
            },
            newPrize() {
                location.href = "#/yunying/activity/newPrize?insert=0&activityId=" + this.activityId;
            },
            editNew(id) {
                location.href = "#/yunying/activity/newPrize?prizeId=" + id + '&edit=0&activityId=' + this.activityId;
            },
            updateStatus(row, status) {
                let message;
                if (status == "0") {
                    this.$confirm('你确定要发布奖励“ ' + row.prizeName + " ”吗？", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$http({
                            method: 'POST',
                            url: this.$util.domain + '/adminapi/v2/operate/prize/updateStatus?prizeId=' + row.prizeId + "&online=1"
                        }).then(response => {
                            if (response.data.error === 10000) {
                                this.prizes.online = "已发布";
                                this.paramAndGet();
                                this.$util.successMsg('奖励发布成功');
                            }
                        })
                    })
                } else {
                    this.$confirm('你确定要撤销奖励“' + row.prizeName + "”吗？", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$http({
                            method: 'POST',
                            url: this.$util.domain + '/adminapi/v2/operate/prize/updateStatus?prizeId=' + row.prizeId + "&online=0"
                        }).then(response => {
                            if (response.data.error === 10000) {
                                this.prizes.online = "未发布";
                                this.paramAndGet();
                                this.$util.successMsg('奖励撤销成功');
                            }
                        })
                    })

                }

            },
            change_status(row, status) {
                this.$http({
                    method: 'POST',
                    url: this.$util.domain + '/adminapi/v1/operate/prize/updateStatus?prizeId=' + row.prizeId + "&online=" + status
                }).then(response => {
                    if (response.data.error === 10000) {
                        this.prizes.online = "未发布";
                        this.paramAndGet();
                    }
                })
            },
            deletePrize(row) {
                this.$confirm('你确定要删除奖励“' + row.prizeName + "”吗？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        method: 'POST',
                        url: this.$util.domain + '/adminapi/v1/operate/prize/delete?prizeId=' + row.prizeId
                    }).then(response => {
                        if (response.data.error === 10000) {
                            this.paramAndGet();
                            this.$util.successMsg('奖励删除成功');
                        }
                    })
                })
            },
            goback() {
                history.back();
            }
        }
    }
</script>
<style>
    .prizeManage .prize {
        padding-left: 20px;
        margin-bottom: 20px;
    }

    .prizeManage .el-select {
        display: inline-block;
    }

    .prizeManage img {
        display: block;
        width: 70%;
        height: 80%;
        margin: 10px;
    }

    .prizeManage span .el-button {
        width: 70px;
        padding: 5px;
        border: solid 1px #999;
    }

    .prizeManage .back {
        right: 70px;
    }

    .prizeManage .el-input {
        display: inline-block;
    }

    .prizeManage .el-button {
        display: inline-block;
    }

    .prizeManage .el-button+.el-button {
        margin-left: 0;
    }

    .prizeManage .search {
        margin-left: 30px;
    }

    .prizeManage .option {
        margin-top: 5px;
    }
</style>


// WEBPACK FOOTER //
// prizeManage.vue?5ac6da6c